import * as Redux from 'redux';

const mobile = (state = {isMobile: false, possible: false}, action) => {
  switch (action.type) {
    case 'MOBILE_POSSIBLE':
      return {...state, possible: action.possible};
    case 'RECEIVE_MOBILE_UPDATE':
      return {...state, isMobile: state.possible && action.mobile};
    default:
      return state;
  }
};

const mobileMedium = (state = {isMedium: false, possible: false}, action) => {
  switch (action.type) {
    case 'MOBILE_POSSIBLE':
      return {...state, possible: action.possible};
    case 'RECEIVE_MOBILEMEDIUM_UPDATE':
      return {...state, isMedium: state.possible && action.mobileMedium};
    default:
      return state;
  }
};
// Tabletansicht immer da weil wir diese ersetzt haben
const mobileBig = (state = {isBig: false, possible: true}, action) => {
  switch (action.type) {
    case 'MOBILE_POSSIBLE':
      return {...state, possible: true};
    case 'RECEIVE_MOBILEBIG_UPDATE':
      return {...state, isBig: action.mobileBig};
    default:
      return state;
  }
};

const cart = (state = {}, action) => {
  switch (action.type) {
    case 'RECEIVE_CART_UPDATE':
      return action.cart;
    default:
      return state;
  }
};
const messecart = (state = {}, action) => {
  switch (action.type) {
    case 'RECEIVE_MESSECART_UPDATE':
      return action.messecart;
    default:
      return state;
  }
};

const updateMessage = (state = {}, action) => {
  switch (action.type) {
    case 'RECIEVE_UPDATE_MSG':
      return action.boo;
    default:
      return state;
  }
};
const loading = (state = false, action) => {
  switch (action.type) {
    case 'RECEIVE_LOADING_UPDATE':
      return action.loading;
    default:
      return state;
  }
};

const resetCookie = (state = false, action) => {
  switch (action.type) {
    case 'RESET_ALL_COOKIE_CLICKS':
      return action.loading;
    default:
      return state;
  }
};

const displayToast = (state = {}, action) => {
  switch (action.type) {
    case 'RECIEVE_DISPLAY_TOAST':
      return action.display;
    default:
      return state;
  }
};

const message = (state = {}, action) => {
  switch (action.type) {
    case 'RECIEVE_MSG':
      return action.msg;
    default:
      return state;
  }
};

const updateAmount = (state = false, action) => {
  switch (action.type) {
    case 'RECIEVE_UPDATE_AMOUNT':
      return !state;
    default:
      return state;
  }
};

const meta = (state = {}, action) => {
  switch (action.type) {
    case 'RECEIVE_META_UPDATE':
      return action.meta;
    default:
      return state;
  }
};

const ordersatzdata = (state = {}, action) => {
  switch (action.type) {
    case 'RECEIVE_ORDERSATZ_DATA':
      return {data: action.data, menge: action.menge, produkttyp: action.produkttyp};
    default:
      return state;
  }
};

const mobile_menu_active = (state = false, action) => {
  switch (action.type) {
    case 'TOGGLE':
      return !state;
    case 'SHOW':
      return true;
    case 'HIDE':
      return false;
    default:
      return state;
  }
};

const reduceStore = Redux.combineReducers({
  cart,
  messecart,
  meta,
  ordersatzdata,
  mobile,
  mobileMedium,
  mobileBig,
  mobile_menu_active,
  loading,
  displayToast,
  message,
  updateMessage,
  updateAmount
});

export default reduceStore;
